import React, { useMemo, useState } from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import { RiArrowDownSLine, RiSearchLine } from 'react-icons/ri';
import {
  colors,
  TextInput,
  Tooltip,
} from '../../../../components/UiComponents/Ui';
import { getAllSuppliersList } from '../../../../Actions/supplierActions';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Popover } from '@mui/material';
import { useGlobalContext } from '../../../../Contexts/GlobalContext';

const ChangeSupplier = ({ _id, type, supplierName }) => {
  const { user } = useGlobalContext();

  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState('');

  const {
    data: allSuppliersList,
    isLoading: allSuppliersListLoading,
    error: allSuppliersListError,
  } = useQuery({
    queryKey: ['all-suppliers-list'],
    queryFn: () => getAllSuppliersList({ orgId: user?.organization?._id }),
    enabled: Boolean(user?.organization?._id),
  });

  const filtered = useMemo(() => {
    const options = Array.isArray(allSuppliersList) ? allSuppliersList : [];
    const q = search.trim().toLowerCase();
    return options.filter((o) => (o.label || '').toLowerCase().includes(q));
  }, [allSuppliersList, search]);

  const close = () => {
    setAnchorEl(null);
    setSearch('');
  };

  const handleSelect = (value) => {
    if (value === _id) return;
    navigate(`/suppliers/${value}/${type.toString()}`, { scroll: false });
  };

  return (
    <>
      <Tooltip position="bottom" content={supplierName || ''}>
        <h1 className="max-w-[300px] overflow-hidden text-ellipsis whitespace-nowrap font-bold text-blue-600 text-lg">
          {supplierName}
        </h1>
      </Tooltip>

      <button
        type="button"
        aria-label="Change supplier"
        disabled={allSuppliersListLoading || Boolean(allSuppliersListError)}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        className="rounded text-blue-600 hover:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50"
      >
        <RiArrowDownSLine size={20} />
      </button>

      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={close}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        PaperProps={{
          sx: {
            width: 300,
            mt: '4px',
            borderRadius: '8px',
            border: `1px solid ${colors.gray200}`,
          },
        }}
      >
        <div className="p-2">
          <TextInput
            autoFocus
            placeholder="Search supplier"
            startIcon={<RiSearchLine size={16} className="text-gray-500" />}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <List
          dense
          disablePadding
          sx={{ maxHeight: 260, overflowY: 'auto', pb: '8px' }}
        >
          {filtered.length ? (
            filtered.map((o) => (
              <ListItemButton
                key={o.value}
                selected={o.value === _id}
                onClick={() => handleSelect(o.value)}
                sx={{
                  fontSize: 16,
                  '&.Mui-selected, &.Mui-selected:hover': {
                    bgcolor: colors.gray100,
                  },
                }}
              >
                {o.label}
              </ListItemButton>
            ))
          ) : (
            <p className="px-4 py-3 text-sm text-gray-500">
              No suppliers found
            </p>
          )}
        </List>
      </Popover>
    </>
  );
};

export default ChangeSupplier;
